<template>
    <v-app>
        <v-toolbar app class="app-toolbar">
            <v-btn :ripple="false" icon @click="$router.go(-1)">
                <v-icon class="icon-light">arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title>Health Tips</v-toolbar-title>
        </v-toolbar>
        <v-content pa-0>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 md4>
                        <v-card v-if="tips != null">
                            <v-img aspect-ratio="1.75" :src="backgroundImage"></v-img>

                            <v-card-title primary-title>
                                <div>
                                    <h3 class="headline mb-0">{{ tips.medical_tips }}</h3>
                                    <div>
                                        {{ tips.medical_tips_description }}
                                    </div>
                                </div>
                            </v-card-title>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>
<script>
    import vas from '@/lib/VASClient';
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
          return {
              tips: null,
              backgroundImage: require('../../../static/img/health_bg.png')
          }
        },
        computed: {
            ...mapState(
                ['auth']
            ),
        },
        mounted() {
            var self = this;

            Loading.show('');

            vas.loadTips(this.auth.user.cell_no, this.auth.user.id).then(function (response) {
                self.tips = response.tips;

                Loading.hide();
            });
        }
    }
</script>
<style>

</style>